import { render, staticRenderFns } from "./UpdateReport.vue?vue&type=template&id=15336b06"
import script from "./UpdateReport.vue?vue&type=script&lang=js"
export * from "./UpdateReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports